import { useIntl } from "react-intl";

const IncidentInvestigation = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.IncidentInvestigation.header",
            defaultMessage: "Incident investigation"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.IncidentInvestigation.body",
            defaultMessage:
                "See all deployments and commits leading up to an incident. Get insights into code changes."
        })
    };
    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default IncidentInvestigation;
